import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/");
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id });
        // Clear hash
        window.history.replaceState(null, "", "/dashboard");
        const target = r.data?.user?.role === "admin" ? "/dashboard" : "/dashboard";
        navigate(target, { state: { user: r.data.user }, replace: true });
        window.location.reload();
      } catch (_e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-teal-600 border-t-transparent rounded-full animate-spin mx-auto"></div>
        <p className="mt-4 text-slate-600 font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
